module.exports = __webpack_public_path__ + "img/36.601da0dc.jpg";